import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const UserList = Loadable(
  lazy(() => import("features/security/components/User/List"))
);
const UserPage = Loadable(
  lazy(() => import("features/security/components/User/Page"))
);
const ChangePassword = Loadable(
  lazy(() => import("features/security/components/ChangePassword"))
);
const EditProfile = Loadable(
  lazy(() => import("features/security/components/EditProfile/EditProfile"))
);
const UserRolesList = Loadable(
  lazy(() => import("features/security/components/UserRoleList"))
);
const UserRolesPage = Loadable(
  lazy(() => import("features/security/components/UserRolePage"))
);

const RolesList = Loadable(
  lazy(() => import("features/security/components/RoleList"))
);

const RolesPage = Loadable(
  lazy(() => import("features/security/components/RolePage"))
);

const RolePermissions = Loadable(
  lazy(() => import("features/security/components/RolePermissions"))
);
const AccessRightsPage = Loadable(
  lazy(() => import("features/security/components/AccessRightsPage"))
);
// const Community = Loadable(
//   lazy(() => import("features/security/components/Community"))
// );
const Settings = Loadable(
  lazy(() => import("features/security/settings/components/Settings"))
);
const routes = {
  path: "security",
  children: [
    { path: "user", element: <UserList /> },
    { path: "user/add", element: <UserPage /> },
    { path: "user/edit/:userID?", element: <UserPage /> },
    { path: "user/change-password", element: <ChangePassword /> },
    { path: "user/editProfile", element: <EditProfile /> },
    { path: "user/role", element: <UserRolesList /> },
    { path: "user/role/add", element: <UserRolesPage /> },
    { path: "user/role/edit/:userID?", element: <UserRolesPage /> },
    { path: "role", element: <RolesList /> },
    { path: "role/add", element: <RolesPage /> },
    { path: "role/edit/:id?", element: <RolesPage /> },
    { path: "permissions", element: <RolePermissions /> },
    { path: "accessLevel", element: <AccessRightsPage /> },
    // { path: "community", element: <Community /> },
    { path: "settings", element: <Settings /> },
  ],
};

export default routes;
